export enum ReferralAds {
  LUCKY_BO = 1,
  MING_TAI = 2,
}

export default ReferralAds
